import GetAccounts from "functions/admin/getAccounts";
import React, { useEffect } from "react";
import { createContext, useContext, useState } from "react";

// Create Context
const AdminContext = createContext();

// Provider Component
export const AdminProvider = ({ children }) => {
  const [activeMerchantId, setActiveMerchantId] = useState(null);
  const [searchFields, setSearchFields] = useState({});
  const [showFilter, setShowFilter] = useState(false);
  const [accounts, setAccounts] = useState(null);
  const [adminId, setAdminId] = useState(null);
  useEffect(() => {
    if (adminId) fetchAccounts();
  }, [adminId]);
  const fetchAccounts = async () => {
    try {
      const response = await GetAccounts();
      if (response) setAccounts(response.data);
    } catch (error) {
      console.error("Failed to fetch accounts:", error);
    }
  };
  return (
    <AdminContext.Provider
      value={{
        activeMerchantId,
        setActiveMerchantId,
        searchFields,
        setSearchFields,
        showFilter,
        setShowFilter,
        accounts,
        setAdminId,
        adminId,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

// Custom Hook
export const useAdmin = () => useContext(AdminContext);
